import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback2';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    imageURL: string;
    title: string;
};

const DiscoverPageSuggestion = ({ imageURL, title }: Props) => {
    const titleHyphenated = title?.replace(/\s+/g, '-');
    const link = `/discover/${titleHyphenated}/`;
    const url = `${imageURL}?auto=webp&format=pjpg&width=100`;
    return (
        <DiscoverATagWrapper>
            <DiscoverATag route secondary to={link}>
                <DiscoverItemImgContainer>
                    <DiscoverItemImg alt={title} src={url} />
                </DiscoverItemImgContainer>
                <DiscoverItemTitle h6>{title}</DiscoverItemTitle>
            </DiscoverATag>
        </DiscoverATagWrapper>
    );
};

export default React.memo<Props>(DiscoverPageSuggestion);

const DiscoverATagWrapper = styled.div`
    width: 100%;
    padding-right: 10px;
`;

const DiscoverATag = styled(Link)`
    display: flex;
    text-decoration: none;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.black};
    border: ${({ theme }) => `1px solid  ${theme.colors.grey400}`};
    border-radius: 2px;

    &:hover {
        text-decoration: none;
        background-color: ${({ theme }) => theme.colors.grey500};
        span,
        h4 {
            color: ${({ theme }) => theme.colors.blue200};
        }
    }

    @media (max-width: ${({ theme }) => `${theme.breakpoints.tabletNarrowWidthNum}px`}) {
        margin-bottom: 9px;
    }
`;

const DiscoverItemImgContainer = styled(Text)`
    max-width: 43px;
    min-width: 43px;
    max-height: 42px;
    min-height: 42px;
    position: relative;
    background-color: ${({ theme }) => theme.colors.grey400};
    border-right: ${({ theme }) => `1px solid  ${theme.colors.grey400}`};
    overflow: hidden;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.tabletNarrowWidthNum}px`}) {
        max-width: 29px;
        min-width: 29px;
        max-height: 28px;
        min-height: 28px;
    }
`;

const DiscoverItemTitle = styled(Text)`
    color: inherit;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    padding: 0 15px;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.tabletNarrowWidthNum}px`}) {
        padding: 0 10px;
    }
`;

const DiscoverItemImg = styled(ImageWithFallback)`
    border-bottom-left-radius: 2px;
    border-top-left-radius: 2px;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;
